// extracted by mini-css-extract-plugin
module.exports = {"root":"ApplyForm_root__Jm68w","displayButton":"ApplyForm_displayButton__1AS1J","displayButtonHeater":"ApplyForm_displayButtonHeater__2CjMp"};